import Icon from '../../components/Icon.vue'

Icon.register({"brands/linkedin-in":{"width":448,"height":512,"paths":[{"d":"M100.3 480H7.4V180.9H100.3V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32 83.5 32 107.6 56.1 107.6 85.8 107.6 115.5 83.5 140.1 53.8 140.1zM448 480H355.3V334.4C355.3 299.7 354.6 255.2 307 255.2 258.7 255.2 251.3 292.9 251.3 331.9V480H158.5V180.9H247.6V221.7H248.9C261.3 198.2 291.6 173.4 336.8 173.4 430.8 173.4 448.1 235.3 448.1 315.7V480z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/linkedin-in.js
// module id = tpuK
// module chunks = 0